import { render } from "./App.vue?vue&type=template&id=c18613ca"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=c18613ca&lang=css"
script.render = render

export default script